export function scrollToHashTarget(hash) {
  if (!hash) return false;

  const targetId = decodeURIComponent(hash.replace(/^#/, ''));
  if (!targetId) return false;

  const target = document.getElementById(targetId);
  if (!target) return false;

  target.scrollIntoView();
  return true;
}
